import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;
const configured = Boolean(
  url &&
  key &&
  !url.includes('REPLACE_WITH') &&
  !key.includes('REPLACE_WITH'),
);

export const supabase = configured ? createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
}) : null;

export const isSupabaseAuthConfigured = configured;

export async function getCurrentAccessToken(): Promise<string | null> {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  let session = data.session;
  if (session?.expires_at && session.expires_at * 1000 <= Date.now() + 60_000) {
    const refreshed = await supabase.auth.refreshSession();
    session = refreshed.data.session;
  }
  return session?.access_token || null;
}

export async function requireBootstrapAccessToken(): Promise<string> {
  const token = await getCurrentAccessToken();
  if (!token) throw new Error('Your email confirmation or sign-in session is not complete. Confirm your email, then sign in before creating an organization.');
  try {
    const [, payload] = token.split('.');
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    const expectedIssuer = `${url}/auth/v1`;
    if (claims.iss !== expectedIssuer || claims.aud !== 'authenticated' || !claims.sub) {
      throw new Error('Your current sign-in session is not valid for tenant setup. Sign out and sign in again.');
    }
  } catch (error: any) {
    if (error.message) throw error;
    throw new Error('Unable to validate your sign-in session. Sign out and sign in again.');
  }
  return token;
}
